// Helper function to get Authorization headers
export const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      "Authorization": `Bearer ${token}`
    };
  };

// Helper function to return a flag emoji based on language
export const getFlagEmoji = (language) => {
    const flags = {
      en: "🇺🇸",
      es: "🇪🇸",
      fr: "🇫🇷",
      de: "🇩🇪",
      it: "🇮🇹",
    };
    return flags[language] || "🌐";
  };

  // Helper function to return a badge color based on status
export const getStatusBadgeColor = (status) => {
    switch (status) {
        case "structuring":
        return "bg-light";
        case "failed_structuring":
        return "bg-danger";
        case "draft":
        return "bg-secondary";
        case "pending":
        return "bg-warning";
        case "processing":
        return "bg-info";
        case "preparing":
        return "bg-primary";
        case "processed":
        return "bg-success";
        case "failed":
        return "bg-danger";
        case "expired":
        return "bg-danger";
        default:
        return "bg-secondary";
    }
};

/*
export async function customFetch(url, options = {}) {
    const token = localStorage.getItem('authToken');
    const headers = {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    };
  
    try {
      const response = await fetch(`${API_BASE_URL}${url}`, {
        ...options,
        headers,
      });
  
      if (response.status === 401) {
        window.location = '/login';
        throw new Error('Unauthorized');
      }
  
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  */